import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filingWorkflowHistoryApi } from "../../utilities/api/filingWorkflowHistoryApi";
import { FilingWorkflowHistory } from "../../utilities/interfaces/FilingWorkflowHistory";

interface filingWorkflowHistoryState {
  histories: FilingWorkflowHistory[];
}

const initialState: filingWorkflowHistoryState = {
  histories: [],
}

const filingWorkflowHistorySlice = createSlice({
  name: 'stateFilingWorkflowHistory',
  initialState,
  reducers: {
    clearHistories(state) {
      state.histories = [];
    },
  },
  extraReducers(builder) {
    builder.addCase(getFilingWorkflowHistoriesByFilingId.fulfilled, (state, action: any) => {
      state.histories = action.payload;
    });
  }
});

export const getFilingWorkflowHistoriesByFilingId = createAsyncThunk('stateFilingWorkflowHistory/getByFilingId', async (id: number) => {
  const response = await filingWorkflowHistoryApi.getByFilingId(id);
  return response;
});

export const { clearHistories } = filingWorkflowHistorySlice.actions;
export default filingWorkflowHistorySlice.reducer;